// extracted by extract-css-chunks-webpack-plugin
module.exports = {"popover":"_3d3tnN","popover-overlay-trigger":"_2mvpH-"};